import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { getPurchaseOrderLookup } from "../../api/purchaseOrderApi";

export default function PurchaseOrderLookup({ propertyId, kind, label, value, onChange, disabled = false, required = false }) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [options, setOptions] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    getPurchaseOrderLookup(propertyId, kind, { search, page, page_size: 10 }).then((res) => {
      if (cancelled) return;
      setOptions((previous) => page === 1 ? res.data.results : [...previous, ...res.data.results]);
      setTotal(res.data.total);
    }).catch(() => { if (!cancelled) setError(`Could not load ${label.toLowerCase()}.`); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [propertyId, kind, search, page, label]);
  return (
    <Box sx={{ minWidth: 220, flex: 1 }}>
      <Autocomplete size="small" options={options} value={value || null} loading={loading} disabled={disabled}
        getOptionLabel={(option) => option.label} isOptionEqualToValue={(a, b) => a.id === b.id}
        filterOptions={(items) => items} onChange={(_, option) => onChange(option)}
        onInputChange={(_, text, reason) => { if (reason === "input" || reason === "clear") { setSearch(text); setPage(1); } }}
        renderInput={(params) => <TextField {...params} label={label} required={required} error={Boolean(error)} helperText={error || undefined} />} />
      {options.length < total && <Button size="small" startIcon={<AddIcon />} disabled={loading || disabled} onClick={() => setPage((current) => current + 1)}>More {label.toLowerCase()}</Button>}
    </Box>
  );
}
